<!-- @veltra/icons generated sha256:dccddca5b55311b7 gen:8 source:src/svg/normal/git-branch.svg -->
<script setup lang="ts">
defineOptions({ name: 'GitBranch' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path d="M15 6a9 9 0 0 0-9 9V3" />
    <circle cx="18" cy="6" r="3" />
    <circle cx="6" cy="18" r="3" />
  </svg>
</template>
